import * as React from 'react';
import IModule from 'models/IModule';

const columns = (handleImport: (id: number) => void) => {
  const data = [
    {
      name: 'Titre',
      selector: 'title',
      sortable: true,
    },
    {
      center: true,
      name: 'Importer',
      maxWidth: '8vw',
      cell: (row: IModule) => (
        <button
          type="button"
          className="btn btn-block btn-primary btn-icon d-flex 
              align-items-center justify-content-center"
          onClick={(): void => handleImport(row.id as number)}
        >
          <i className="fa fa-edit" />
        </button>
      ),
    },
  ];
  return data;
};

export default columns;
